import React from 'react';
import { Tooltip } from 'seedly-component-library';
import Image from 'next/image';
import Avatar from 'seedly-component-library/avatar-new';

interface OwnProps {
  description: string;
  name: string;
  editProfileButton?: React.ReactNode;
  profileDetail?: React.ReactNode;
  image: string;
  badgeDescription?: string;
  badgeUrl?: string;
}

const ProfileAvatar = (props: OwnProps) => {
  const {
    description,
    name,
    editProfileButton,
    profileDetail,
    badgeDescription,
    badgeUrl,
  } = props;
  let { image } = props;

  if (image && image.indexOf('facebook') !== -1) {
    image += '?type=large';
  }

  let badge;

  if (badgeUrl && badgeDescription) {
    badge = (
      <Tooltip
        showToolTip
        placement="bottom"
        renderTriggerButton={() => (
          <Image src={badgeUrl} width={40} height={48} />
        )}
        renderToolTipBody={() => <div>{badgeDescription}</div>}
      />
    );
  }

  return (
    <div className="card p-0 h-fit relative">
      <div className="flex flex-col w-full items-center pt-[42px] lg:pt-4 rounded avatar-background">
        {editProfileButton}
        <Avatar name={name} src={image} badge={badge} sizeClass="avatar-40" />
      </div>
      {!profileDetail && (
        <div className="p-4">
          <p className="text-neutral-500 break-words">{description}</p>
        </div>
      )}
      {profileDetail}
    </div>
  );
};

export default ProfileAvatar;
